module.exports = __webpack_public_path__ + "img/chatCanLinkIcon.9fc36886.svg";